'use client';

import React from 'react';
import Link from 'next/link';

export default function PromoBanner() {
    return (
        <div className="bg-violet-900 text-white px-4 py-2 text-center relative z-50">
            <div className="text-xs sm:text-sm font-medium flex items-center justify-center gap-2">
                <span className="bg-white/20 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide">New</span>
                <span>
                    Waitlistly now supports <span className="font-bold">Webhooks</span> for Zapier, Make & Slack integration.
                </span>
                <Link
                    href="/help/webhooks"
                    className="inline-flex items-center gap-1 underline hover:text-violet-200 transition-colors ml-1"
                >
                    Learn more
                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                </Link>
            </div>
        </div>
    );
}
